import UPDATE_MY_ALERTS_MODAL_SLOT from '../actionTypes/MyAlertsModalActionTypes';

export const updateMyAlertsSlot = (payload) => ({
    type: UPDATE_MY_ALERTS_MODAL_SLOT,
    payload,
});

export default {
    updateMyAlertsSlot,
};
